


<ul>
    <li *ngFor="let category of categories" (click)="selectedId.emit(category.id)">
      {{ category.name }}
      <!-- Recursively render subcategories if they exist -->
      <app-recursive-list *ngIf="category.subcategories" [categories]="category.subcategories"></app-recursive-list>
    </li>
  </ul>
  